import { createContext } from 'react';
import { CustomerCompareList } from '../../../services/src/magento/compare-list.service';

export const CustomerCompareListContext = createContext<{
  /**
   * null = empty, undefined = not loaded yet
   */
  compareList: CustomerCompareList | null | undefined;
  isLoading: boolean;
  refetch: () => void;
}>({
  compareList: undefined,
  isLoading: true,
  refetch: () => ({}),
});
